import { ILink } from './types';

export const BASE_LINKS: ILink[] = [
  {
    href: 'https://hc.cian.ru/hc/ru',
    text: 'Справочный центр',
    name: 'help',
  },
  {
    href: '/legal-documents/pravila_polzovaniya_sajtom_cian_0/',
    text: 'Юридические документы',
    name: 'legal-documents',
  },
  {
    href: '/price/?from=footer',
    text: 'Тарифы и цены',
    name: 'price',
  },
  {
    href: '/contacts/',
    text: 'Помощь',
    name: 'contact',
  },
  {
    href: '/help/re/advert/',
    text: 'Реклама на сайте',
    name: 'advert',
  },
  {
    href: '/help/add/fairplay/',
    text: 'Программа «Работаю честно»',
    name: 'fairplay',
  },
  {
    href: '/promo/adv/',
    text: 'Продвижение',
    name: 'promo',
  },
  {
    href: '/help/auction/',
    text: 'Аукцион',
    name: 'auction',
  },
  {
    href: '/map/',
    text: 'Поиск на карте',
    name: 'search_on_map',
  },
  {
    href: '/tv/',
    text: 'Реклама ЦИАН на ТВ',
    name: 'tv',
  },
  {
    href: '/vacancies/',
    text: 'Вакансии агентств',
    name: 'vacancies',
  },
  {
    href: '/ipoteka/calculator/',
    text: 'Ипотечный калькулятор',
    name: 'mortgage-calculator',
  },
  {
    href: '/legal-check/?source=footer',
    text: 'Проверка недвижимости',
    name: 'legal-check',
  },
];

export const ADDITIONAL_LINKS: ILink[] = [
  {
    href: '/sitemap/',
    text: 'Карта сайта',
    name: 'sitemap',
  },
  {
    href: '/svezhie-obyavleniya/',
    text: 'Свежие объявления',
    name: 'svezhie-obyavleniya',
  },
];

export const CAREER_LINK: ILink = {
  href: 'https://team.cian.tech/',
  text: 'Карьера в Циан',
  name: 'career',
  theme: 'primary',
};
